import { AfterViewInit, Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Artist } from 'src/app/_models/artist.model';
import { AppSettings } from 'src/app/app.settings';
import { SwiperOptions } from 'swiper/types';

@Component({
    selector: 'app-artist-carousel-item',
    templateUrl: './artist-item.component.html',
    styleUrls: ['./artist-item.component.scss'],
    standalone: false
})
export class ArtistCarouselItemComponent implements AfterViewInit {
  @Input() index: number;
  @Input() artists: Artist[] = null;
  @Input() config: SwiperOptions = null;
  @ViewChildren('artistSwiper') artistSwiper: QueryList<ElementRef>;
  public timer = false;

  constructor(public settings: AppSettings) { }

  ngAfterViewInit(): void {
    this.initSwiper();
  }

  public initSwiper(): void {
    this.artistSwiper?.forEach((swiper) => {
      this.config.initialSlide = this.index;
      Object.assign(swiper.nativeElement, this.config);
      swiper.nativeElement.initialize();
    });
  }

  public slideNext() {
    this.artistSwiper?.forEach((swiper => {
      setTimeout(() => {
        swiper?.nativeElement?.swiper?.slideNext(500);
      }, this.index * 100);
    }));
  }

  public slidePrev() {
    this.artistSwiper?.forEach((swiper => {
      setTimeout(() => {
        swiper?.nativeElement?.swiper?.slidePrev(500);
      }, this.index * 100);
    }));
  }
}
